/* tslint:disable */
/* eslint-disable */
/**
 * STRY API
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime';
import {
    SectionQuestion,
    SectionQuestionFromJSON,
    SectionQuestionFromJSONTyped,
    SectionQuestionToJSON,
} from './';

/**
 * 
 * @export
 * @interface SurveySection
 */
export interface SurveySection {
    /**
     * 
     * @type {number}
     * @memberof SurveySection
     */
    id?: number;
    /**
     * Enumeration type of either questions or promis-survey.
     * @type {string}
     * @memberof SurveySection
     */
    type?: string;
    /**
     * 
     * @type {Array<string>}
     * @memberof SurveySection
     */
    preMessages?: Array<string>;
    /**
     * 
     * @type {Array<SectionQuestion>}
     * @memberof SurveySection
     */
    questions?: Array<SectionQuestion>;
    /**
     * 
     * @type {number}
     * @memberof SurveySection
     */
    estimatedNumQuestions?: number;
}

export function SurveySectionFromJSON(json: any): SurveySection {
    return SurveySectionFromJSONTyped(json, false);
}

export function SurveySectionFromJSONTyped(json: any, ignoreDiscriminator: boolean): SurveySection {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        
        'id': !exists(json, 'id') ? undefined : json['id'],
        'type': !exists(json, 'type') ? undefined : json['type'],
        'preMessages': !exists(json, 'pre-messages') ? undefined : json['pre-messages'],
        'questions': !exists(json, 'questions') ? undefined : ((json['questions'] as Array<any>).map(SectionQuestionFromJSON)),
        'estimatedNumQuestions': !exists(json, 'estimated-num-questions') ? undefined : json['estimated-num-questions'],
    };
}

export function SurveySectionToJSON(value?: SurveySection | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        
        'id': value.id,
        'type': value.type,
        'pre-messages': value.preMessages,
        'questions': value.questions === undefined ? undefined : ((value.questions as Array<any>).map(SectionQuestionToJSON)),
        'estimated-num-questions': value.estimatedNumQuestions,
    };
}


